
/**
 * 상품 타입
 */
export type OrderListResponseOrdersItemItemType = typeof OrderListResponseOrdersItemItemType[keyof typeof OrderListResponseOrdersItemItemType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderListResponseOrdersItemItemType = {
  COURSE: 'COURSE',
  EBOOK: 'EBOOK',
  SERVICE: 'SERVICE',
  SUBSCRIPTION: 'SUBSCRIPTION',
  DIGITAL_GOODS: 'DIGITAL_GOODS',
  OTHER: 'OTHER',
} as const;
